export enum UserStatus {
  All = "all",
  Blocked = "blocked",
  Admin = "admin",
}
